module.exports = __webpack_public_path__ + "img/chat-ico.57f52980.png";